class PromoProduct {
  constructor() {
    this.productCards = document.querySelectorAll('.banner-main--product-card');
    this.init();
  }

  init() {
    this.productCards.forEach(card => {
      const claimElement = card.querySelector('.claimPercent');
      const claimTextWrapper = card.querySelector('.product-card--claim-text');
      const progressBarFill = card.querySelector('.banner-main--product-card-progress-fill');
      const timerElement = card.querySelector('.prizeTimer');

      // If required elements are missing → mark ended and skip
      if (!claimElement || !timerElement || !claimTextWrapper) {
        card.classList.add('ended-promo');
        return;
      }

      const durationStr = timerElement.dataset.duration || "";

      // If duration is blank → mark card as "starting soon"
      if (!durationStr || durationStr.trim() === "") {
        card.classList.add("ended-promo");
        claimTextWrapper.innerHTML = `<strong>New promotion starts soon</strong>`;
        timerElement.textContent = "";
        return;
      }

      const sold = parseInt(claimElement.dataset.sold) || 0;
      const available = parseInt(claimElement.dataset.available) || 0;

      let percent = available > 0 ? Math.round((sold / available) * 100) : 0;

      // update percent UI
      claimElement.textContent = `${percent}%`;
      if (progressBarFill) progressBarFill.style.width = `${percent}%`;

      // GET CURRENT + NEXT WINDOWS (you removed this before → error)
      const { current, next } = this.getWindows(durationStr);
      const now = new Date();

      // remove class by default
      card.classList.remove('ended-promo');

      // SOLD OUT logic
      if (sold >= available) {
        if (!next) {
          claimTextWrapper.innerHTML = `<strong>Promotion has ended</strong>`;
          timerElement.textContent = "";
          card.classList.add('ended-promo');
          return;
        }
      }

      // ACTIVE PROMO
      if (current && now <= current.end && sold < available) {
        claimTextWrapper.innerHTML = `
          <span 
            class="claimPercent" 
            data-sold="${sold}" 
            data-available="${available}"
          >
            ${percent}%
          </span> claimed today
        `;
        this.startCountdown(timerElement, { start: current.start, end: current.end }, card);
        card.classList.remove('ended-promo');
        return;
      }

      // FUTURE PROMO COMING
      if (next) {
        claimTextWrapper.innerHTML = `Coming soon...`;
        this.startCountdown(timerElement, { start: next.start, end: next.start }, card);
        card.classList.add('promo-countdown-wrapper');
        return;
      }

      // NO PROMOS LEFT
      claimTextWrapper.innerHTML = `<strong>Promotion has ended</strong>`;
      timerElement.textContent = "";
      card.classList.add('ended-promo');
      card.classList.remove('promo-countdown-wrapper');
    });
  }

  // PARSE WINDOW STRING → { start, end }
  parseWindow(str) {
    const [startStr, endStr] = str.split(" - ").map(s => s.trim());
    return {
      start: this.parseDateTime(startStr),
      end: this.parseDateTime(endStr)
    };
  }

  parseDateTime(str) {
    if (!str || typeof str !== "string") return null;

    if (!str.includes("-")) str += "-00:00";

    const [datePart, timePart] = str.split("-");
    if (!datePart) return null;

    const [d, m, y] = datePart.split("/").map(Number);
    const [h, min] = (timePart || "00:00").split(":").map(Number);

    return new Date(Date.UTC((y || 0) + 2000, (m || 1) - 1, d || 1, h || 0, min || 0));
  }

  // RETURN: { current, next }
  getWindows(durationStr) {
    const now = new Date();
    const windows = durationStr
      .split(",")
      .map(w => this.parseWindow(w.trim()))
      .sort((a, b) => a.start - b.start);

    let current = null;
    let next = null;

    for (let win of windows) {
      if (now >= win.start && now <= win.end) {
        current = win;
      } else if (now < win.start && !next) {
        next = win;
      }
    }

    return { current, next };
  }

  // COUNTDOWN HANDLER
  startCountdown(element, windowRange, card) {
    const tick = () => {
      const now = new Date();
      let target;

      if (windowRange.start.getTime() !== windowRange.end.getTime()) {
        // Active promo → countdown to END
        target = windowRange.end;
        card.classList.remove('ended-promo'); // ✅ only remove when active
      } else {
        // Future promo → countdown to START
        target = windowRange.start;
        // ❌ remove this line
        // card.classList.add('ended-promo');
      }

      const diff = target - now;

      if (diff <= 0) {
        clearInterval(interval);

        // Hide all prize timers
        document.querySelectorAll('.prizeTimer').forEach(timer => {
          timer.textContent = "";
        });

        // Refresh ALL product card states
        this.init();
        return;
      }

      const mins = Math.ceil(diff / 60000);
      const hrs = Math.floor(mins / 60);
      const m = mins % 60;

      element.textContent = `${hrs}h:${m.toString().padStart(2, "0")}m`;
    };

    tick();
    const interval = setInterval(tick, 1000);
  }
}

const promoProduct = new PromoProduct();